import { DocumentCornSchema } from '@eigtech/documents-types';
import { z } from 'zod';
import { ProcessingStateSchema } from './processing.js';
export const PhotoReportPhotoSchema = z.object({
    dateTaken: z.string(),
    description: z.string(),
    image: z.string(),
    label: z.string(),
    takenBy: z.string(),
});
export const PhotoReportTemplateParamsSchema = z.object({
    claimNumber: z.string().optional(),
    companyAddress: z.string().array(),
    companyName: z.string(),
    date: z.string(),
    insuredName: z.string(),
    jobNumber: z.string().optional(),
    photos: PhotoReportPhotoSchema.array(),
    policyNumber: z.string().optional(),
    title: z.string(),
    logoPath: z.string().optional(),
});
export const PhotoReportStateSchema = z.enum([
    'building',
    'complete',
    'compressing',
    'error',
    'pending',
    'recording',
]);
export const PhotoReportRecordSchema = ProcessingStateSchema.extend({
    documentIds: z.string().array().optional(),
    photoReportId: DocumentCornSchema.optional(),
    state: PhotoReportStateSchema,
});
